import { alpha } from '@mui/material/styles';

export interface CustomShadows {
    card: string;
    cardHover: string;
    // Softer pair for dense grids (bot list), where the default stacks up
    cardSoft: string;
    cardSoftHover: string;
    popover: string;
}

declare module '@mui/material/styles' {
    interface Theme {
        customShadows: CustomShadows;
    }
    interface ThemeOptions {
        customShadows?: CustomShadows;
    }
}

/**
 * Layered shadows tinted with the dark brand color instead of black:
 * a tight contact shadow for definition plus a short ambient one for depth.
 * @param tint dark brand color, e.g. colors.primaryDark
 */
export const buildCustomShadows = (tint: string): CustomShadows => {
    const shade = (opacity: number) => alpha(tint, opacity);

    return {
        card: `0 1px 2px ${shade(0.2)}, 0 3px 8px ${shade(0.14)}`,
        cardHover: `0 2px 4px ${shade(0.22)}, 0 8px 18px ${shade(0.22)}`,
        cardSoft: `0 1px 2px ${shade(0.06)}, 0 4px 16px ${shade(0.08)}`,
        cardSoftHover: `0 2px 4px ${shade(0.08)}, 0 12px 28px ${shade(0.14)}`,
        popover: `0 4px 10px ${shade(0.2)}, 0 12px 28px ${shade(0.26)}`,
    };
};
